import React from 'react'

const ShowTopics = ({ title, topics, isSearchPage }) => (
  <>
    {topics.length > 0 ? (
      <strong>{title}: </strong>
    ) : null}
    {
      isSearchPage ? (
        topics
          .map(category => (<span key={category.id}>{category.name}</span>))
          .reduce((acc, x) => acc === null ? [x] : [acc, ', ', x], null)
      )
        : <div className='topics-section'>
          {topics
            .map(category => (<a href={`/#/search?q=*&aois=&industries=&geos=&topics=${category.id}&contentTypes=&dateFrom=&dateTo=&sortOrder=Newest`} 
                className='topic-tags' key={category.id} 
                data-gm-u-pn="content"  
                data-gm-u-c="search"
                data-gm-u-e="search_topictag" 
                data-gm-u-v={category.name}
                data-gm-u-a="click">{category.name}</a>))
            .reduce((acc, x) => acc === null ? [x] : [acc, ' ', x], null)}
        </div>
    }
  </>
)

export default ShowTopics
